import $ from 'jquery';
import { COUNTRY_CODES } from '../constants/enums';

export default class QueryStringService {
    constructor() {

    }

    getSearchParam(searchString, defaultValue=null) {
        //in dev env using querystrings to test other localParam5 packages without having to 
        // create a new package and orderline in AIDA
        const urlParams = new URLSearchParams(window.location.search);
        const param = urlParams.get(searchString);
        if (param !== null && param !== undefined && param !== "")
            return param;
        return defaultValue;
    }

    getCurrentCountry() {
        //in dev env using querystrings to test regions
        const urlParams = new URLSearchParams(window.location.search);
        const country = urlParams.get('region');
        if (country !== null && country !== undefined && country !== "")
            return country;

        //in production env
        const hostString = window.location.hostname;
        const substrs = hostString.split('.');
        if (substrs.length > 1) {
            const tld = substrs[substrs.length - 1].toLowerCase();
            const possibleCodes = Object.values(COUNTRY_CODES);
            if (tld !== 'com') {
                return tld;
            } else {
                const subdomain = substrs[0].toLowerCase();
                for (const code of possibleCodes) {
                    if (subdomain.endsWith('-' + code)) {
                        return code;
                    }
                }
                return tld;
            }
        }
        return null;
    }
}